import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Tag, TextLink } from '../../../design-system';
import { TagsWrapper, FilterTagWrapper } from './FilterTags.style';
import useFilterTags from '../../hooks/useFilterTags';

const FilterTagsAlpha: React.FC = () => {
  const { t } = useTranslation();
  const {
    isCaMarket,
    confirmedFilters,
    renderStringFilters,
    filterCount,
    shouldShowRemoveAllFilters,
    resetAllFilters,
    handleRemoveFilter,
  } = useFilterTags();

  const renderContent = useMemo(() => {
    if (!filterCount) return <></>;
    return (
      <TagsWrapper data-testid="filter-tags-wrapper">
        <FilterTagWrapper data-testid="filter-tags-list">
          {isCaMarket && (
            <Tag
              size="md"
              variant="read-only"
              label={t(`promo.filters.filterOptions.vehicleType.${confirmedFilters.vehicleType}`)}
              data-testid="vehicle-type-tag"
            />
          )}
          {renderStringFilters.map((filter) => {
            const { label, filterType, value, showType, preLabel } = filter;
            const shouldRemoveCloseIcon =
              confirmedFilters.offerRegion.length === 1 && value === 'NAT';
            const tagLabel = `${showType ? `${preLabel}: ` : ''}${label}`;
            if (shouldRemoveCloseIcon) {
              return (
                <Tag
                  key={`${filterType}+${label}+${value}`}
                  size="md"
                  variant="read-only"
                  label={tagLabel}
                  data-testid={`filter-tag-${filterType}-${value}`}
                />
              );
            }
            return (
              <Tag
                key={`${filterType}+${label}+${value}`}
                size="md"
                variant="removable"
                label={tagLabel}
                aria-label={`remove ${label} ${filterType} filter`}
                onClick={() => handleRemoveFilter(filterType, value)}
                data-testid={`filter-tag-${filterType}-${value}`}
              />
            );
          })}
          {shouldShowRemoveAllFilters && (
            <TextLink
              size="sm"
              variant="standalone"
              onClick={resetAllFilters}
              data-testid="reset-all-filters-button"
            >
              {t('promo.filterTags.resetAll')} ({filterCount})
            </TextLink>
          )}
        </FilterTagWrapper>
      </TagsWrapper>
    );
  }, [
    confirmedFilters.offerRegion.length,
    confirmedFilters.vehicleType,
    filterCount,
    handleRemoveFilter,
    isCaMarket,
    renderStringFilters,
    resetAllFilters,
    shouldShowRemoveAllFilters,
    t,
  ]);

  return renderContent;
};

export default FilterTagsAlpha;
